import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = [<>
    ✔ Fase de estabilización para <strong data-id="element-293">frenar las peleas HOY</strong>.
  </>, <>
    ✔ Ejercicios guiados de <em data-id="element-294">reconexión emocional y perdón</em>.
  </>, <>
    ✔ Guía exacta para que el estrés financiero{' '}
    <strong data-id="element-295">no rompa la confianza</strong>.
  </>, <>
    ✔ El <strong data-id="element-296">'Contrato de Convivencia en Crisis'</strong> — plantilla lista
    para usar.
  </>, <>
    ✔ Plan S.O.S de Emergencia para <em data-id="element-297">desescalar momentos de tensión</em>.
  </>, <>
    ✔ Mapa de 'Micro-Oasis' para <strong data-id="element-298">recuperar la intimidad</strong> sin
    gastar dinero.
  </>];
export function UniqueMechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-299">
      <div className="max-w-4xl mx-auto px-6" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-301">
          <div className="text-center mb-16" data-id="element-302">
            <div className="inline-block bg-[#34D399]/20 text-[#34D399] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-303">
              LA SOLUCIÓN
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif" data-id="element-304">
              Lo que vas a encontrar dentro del material
            </h2>
            <p className="text-[#C4B5FD] text-lg mt-6 max-w-2xl mx-auto" data-id="element-305">
              No es teoría aburrida. Es un{' '}
              <strong data-id="element-306">plan de acción directo</strong> para aplicar esta misma
              noche.
            </p>
          </div>

          <div className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-14 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)]" data-id="element-307">
            <ul className="space-y-8" data-id="element-308">
              {benefits.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1,
              ease: 'easeOut'
            }} className="flex items-start gap-5" data-id="element-309">
                  <span className="text-lg md:text-xl text-[#1E0A3C] font-medium leading-relaxed font-sans" data-id="element-310">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}